// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 主页
import home from '@/views/home'
// 区域管理

import Area_mn from '@/views/area_mn/Area_mn'
// 任务管理



// 车辆管理
import Vehicle from '@/views/vehicle_mn/Vehicle_mn'
// 运维管理
// 巡检工单
import Operation from '@/views/operation_mn/Operation_mn'
// 故障工单
import Fault_order from '@/views/operation_mn/Fault_order'
// 综合工单
import Zh_order from '@/views/operation_mn/Zh_order'
// 地图管理
import Map_mn from '@/views/map_mn/Map_mn'
// 线路管理
import Line_mn from '@/views/map_mn/Line_mn'
// 站点管理
import Station_mn from '@/views/map_mn/Station_mn'
// 车辆监控
import Monitoring from '@/views/monitoring/Monitoring'
// 单车监控






// 启用路由
Vue.use(Router);






// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },
    {
        path: '/monitoring/Monitoring',
        name: '车辆监控',
        component: Monitoring,
        meta: {
            requireAuth: true
        }
    },
    
        {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [
            {
                path: '/home',
                name: '主页',
                component: home,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/area_mn/Area_mn',
                name: '区域管理',
                component: Area_mn,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/area_mn/task_mn',
                name: '任务管理',
                component: Area_mn,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/vehicle_mn/Vehicle_mn',
                name: '车辆管理',
                component: Vehicle,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/operation_mn/Operation_mn',
                name: '巡检工单',
                component: Operation,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/operation_mn/Fault_order',
                name: '故障工单',
                component: Fault_order,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/operation_mn/Zh_order',
                name: '故障工单',
                component: Zh_order,
                meta: {
                    requireAuth: true
                }
            },

            {
                path: '/map_mn / Map_mn',
                name: '地图管理',
                component: Map_mn,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/map_mn/Line_mn',
                name: '线路管理',
                component: Line_mn,
                meta: {
                    requireAuth: true
                }
            },

            {
                path: '/map_mn/Station_mn',
                name: '站点管理',
                component: Station_mn,
                meta: {
                    requireAuth: true
                }
            },
            
             ],
        // 


    },

    ]
})




// WEBPACK FOOTER //
// ./src/router/index.js